import React, { useEffect, useRef, useState } from 'react';
import Files from 'react-files';
import cx from 'classnames';
import { EditorState } from 'draft-js';
import { getMinutes } from '@shootsta/format-seconds';

import { getContentState, RichTextEditor } from '../../../../RichTextEditor';
import CommentAssets from '../../../components/CommentAssets';
import { Button, Icon } from '../../../../../ui-kit';
import TimestampLabel from '../../../components/Comment/components/CommentV2/components/TimestampLabel';
import VisibilityDropdown from '../../../components/VisibilityDropdown';

import '../styles/_comment-text-editor-v2.scss';

const ALLOWED_FILES_TYPES = [
'image/*',
'video/*',
'audio/*',
'.pdf',
'.doc',
'.docx',
'.ppt',
'.pptx',
'.rtf',
'.zip',
'.rar',
'.xls',
'.xlsx',
'.svg',
'.csv',
'.txt'];





























function CommentTextEditorV2({
  onUpdateContent,
  placeholder,
  editorState,
  inputType,
  onSave,
  disabled,
  onCancel,
  assetIds: CommentAssetIds = [],
  commentId,
  onFilesChange,
  canDeleteAsset,
  organisationId,
  onFocus,
  onBlur,
  setFocusOnMount = false,
  timestamp,
  visibility,
  onChangeVisibility,
  addFilesToQueue,
  isShootstaUser,
  organisationName,
  allowedWriteVisibilityOptions = [],
  hideTimestamp,
  hideVisibility
}) {
  const [assetIds, setAssetIds] = useState(CommentAssetIds);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [hideFooterControls, setHideFooterControls] = useState(setFocusOnMount);
  const fileRef = useRef();
  const parentRef = useRef();

  useEffect(() => {
    const { plainText } = getContentState(editorState);

    setBtnDisabled(!plainText);
  }, [editorState]);

  const handleFilesChange = async (files) => {
    if (!files.length) {
      return;
    }

    const filesPayload = files.map((file) => {
      const { name: fileName } = file;
      const bucketKey = `organisation/${organisationId}/comments/${fileName}`;
      return {
        bucketKey,
        file,
        organisationId,
        metaData: { type: file.type, size: file.size }
      };
    });

    const newAssetIds = await addFilesToQueue(filesPayload);

    setAssetIds((prev) => [...prev, ...newAssetIds]);

    if (onFilesChange) {
      onFilesChange([...assetIds, ...newAssetIds]);
    }

    if (!fileRef.current) return;

    fileRef.current.removeFiles();
  };

  const handleCommentAssetsChange = (updatedAssetIds) => {
    setAssetIds(updatedAssetIds);
    if (onFilesChange) {
      onFilesChange(updatedAssetIds);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
      parentRef.current &&
      !parentRef.current.contains(event.target) &&
      onBlur)
      {
        onBlur();
        setHideFooterControls(true);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onBlur]);

  useEffect(() => {
    const handleFocus = () => {
      setHideFooterControls(false);
    };

    if (
    parentRef.current &&
    parentRef.current.lastChild &&
    parentRef.current.lastChild.querySelector('.public-DraftEditor-content') &&
    parentRef.current.lastChild.querySelector('.public-DraftEditor-content').addEventListener)
    {
      parentRef.current.lastChild.
      querySelector('.public-DraftEditor-content').
      addEventListener('focus', handleFocus);
    }

    return () => {
      if (
      parentRef.current &&
      parentRef.current.lastChild &&
      parentRef.current.lastChild.querySelector('.public-DraftEditor-content') &&
      parentRef.current.lastChild.querySelector('.public-DraftEditor-content').addEventListener)
      {
        parentRef.current.lastChild.
        querySelector('.public-DraftEditor-content').
        removeEventListener('focus', handleFocus);
      }
    };
  }, [parentRef]);

  return (
    <div className="comment-text-editor-v2" ref={parentRef}>
      <RichTextEditor
        onUpdateContent={onUpdateContent}
        placeholder={placeholder}
        editorState={editorState}
        inputType={inputType}
        onSave={onSave}
        disabled={disabled}
        onCancel={onCancel}
        organisationId={organisationId}
        hideControls
        onFocus={onFocus}
        setFocusOnMount={setFocusOnMount}>

        {!hideFooterControls ?
        <div className="comment-text-editor-v2__container">
            <CommentAssets
            isV2Design
            assetIds={assetIds}
            commentId={commentId}
            canDelete={canDeleteAsset}
            onFilesChange={handleCommentAssetsChange} />

            <div className="comment-text-editor-v2__container--footer">
              {onFilesChange &&
            <div className="comment-text-editor-v2__container--footer__attachment">
                  <Files
                onChange={handleFilesChange}
                accepts={ALLOWED_FILES_TYPES}
                minFileSize={1}
                clickable={!disabled}
                ref={fileRef}
                multiple>

                    <Icon
                  name="attachment"
                  size={20}
                  onClick={Function.prototype}
                  hoverColor="black"
                  color="denim" />

                  </Files>
                </div>}

              <div className="comment-text-editor-v2__container--footer__controls">
                {hideTimestamp !== true && timestamp !== undefined && timestamp !== null &&
              <TimestampLabel
                timestamp={getMinutes(timestamp)}
                visibility={visibility} />}



                {hideVisibility !== true && (
              visibility !== undefined && visibility !== null || onChangeVisibility) &&

              <VisibilityDropdown
                id="comment-v2-body-visibility-edit-mode"
                allowedWriteVisibilityOptions={allowedWriteVisibilityOptions}
                value={visibility || 'PUBLIC'}
                isShootstaUser={isShootstaUser}
                organisationName={organisationName}
                onChange={onChangeVisibility}
                hideLabel={Boolean(commentId)} />}


                {commentId ?
              <>
                    <Button
                  onClick={onCancel}
                  type="TERTIARY"
                  disabled={disabled}>

                      Cancel
                    </Button>
                    <Button
                  onClick={onSave}
                  disabled={btnDisabled || disabled}
                  type="SECONDARY">

                      Save
                    </Button>
                  </> :

              <Icon
                name="send"
                color={btnDisabled ? 'nevada' : 'white'}
                size={16}
                onClick={onSave}
                className={cx(
                  'comment-text-editor-v2__container--footer__controls--send-btn',
                  {
                    'comment-text-editor-v2__container--footer__controls--send-btn-disabled':
                    btnDisabled || disabled
                  }
                )} />}


              </div>
            </div>
          </div> :
        null}
      </RichTextEditor>
    </div>);

}

export default CommentTextEditorV2;